import React, { Fragment, PureComponent } from 'react';
import { graphql } from 'react-relay';
import { Toaster } from 'react-hot-toast';
import App from './App';
import { Route, Switch } from 'react-router-dom';
import Routes from './routes';
import { isLoggedIn } from './lib/LoginUtils';
import { LoginFormContainer } from './components/login-form/login-form';
import { QueryRenderer } from 'react-relay';
import modernEnvironment from './lib/RelayUtils';
import { ResetPasswordFormContainer } from './components/reset-password/reset-password-form';
import { AppProvider } from './AppContext';

class AdminApp extends PureComponent {
	render() {
		const {
			isAdmin,
			query: { viewer },
		} = this.props;

		return (
			<AppProvider isAdmin={isAdmin}>
				<App viewer={viewer}>
					<Routes isAdmin={isAdmin} />
				</App>
			</AppProvider>
		);
	}
}

const AdminAppContainer = () => {
	return (
		<QueryRenderer
			environment={modernEnvironment}
			query={graphql`
				query AppWrapper_Query {
					viewer {
						me {
							canDelete
						}
						...App_viewer
					}
				}
			`}
			render={({ error, props }) => {
				if (error && error.res.status === 401) {
					return null;
				}

				if (error) {
					return <div>{error.message}</div>;
				}

				if (props) {
					const canDelete = props.viewer.me.canDelete;
					return <AdminApp isAdmin={canDelete} query={{ viewer: props.viewer }} />;
				}

				return <div>Loading...</div>;
			}}
		/>
	);
};

export class AppWrapper extends PureComponent {
	state = {
		isAuthenticated: isLoggedIn(),
	};

	render() {
		const { isAuthenticated } = this.state;
		return (
			<Fragment>
				<Toaster position="top-right" />
				<Switch>
					<Route path="/reset-password/:userId/:token" component={ResetPasswordFormContainer} />
					<Route path="/" render={() => (!isAuthenticated ? <LoginFormContainer /> : <AdminAppContainer />)} />
				</Switch>
			</Fragment>
		);
	}
}



// WEBPACK FOOTER //
// src/AppWrapper.js